import React from 'react'
import { useTranslation, withTranslation, WithTranslation } from 'react-i18next'
import bigData from '../../images/big-data.png'
import designDevelopment from '../../images/design-development.png'
import webMobile from '../../images/web-mobile.png'
// import SectionWrapper from '../../wrapperComponents/SectionWrapper'
import './Services.scss'

interface IProps {
  // setActive: () => void
}

const Services: React.FunctionComponent<IProps & WithTranslation> = (props) => {
  const { t } = useTranslation()

  return (
    <div className="view">
      <div className="text-block">
        <h2>{t('services.title')}</h2>
        <p>{t('services.intro')}</p>
      </div>

      <div className="services-icons">
        <div className="service-wrapper">
          <img src={bigData} title={t('services.big_data') as string} alt={`${t('services.big_data')} icon`} />
          <h3>{t('services.big_data')}</h3>
        </div>
        <div className="service-wrapper">
          <img
            src={designDevelopment}
            title={t('services.design_development') as string}
            alt={`${t('services.design_development')} icon`}
          />
          <h3>{t('services.design_development')}</h3>
        </div>
        <div className="service-wrapper">
          <img src={webMobile} title={t('services.web_mobile') as string} alt={`${t('services.web_mobile')} icon`} />
          <h3>{t('services.web_mobile')}</h3>
        </div>
      </div>
    </div>
  )
}

export default withTranslation()(Services)
